<template>
  <div class="w-full">
    <label
      v-if="label"
      :for="name"
      class="block mb-2 pl-4 text-sm font-semibold dark:text-gray-300 text-primary"
    >
      {{ $t(label || "") }}<span v-if="required" class="text-danger"> *</span>
    </label>
    <div class="relative">
      <select
        :value="inputValue"
        @change="onChange"
        :disabled="disabled"
        class="border-2 text-sm rounded-2xl focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-3 py-3 outline-hidden ring-2 ring-transparent dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-200 dark:focus:ring-blue-500 dark:focus:border-blue-500 appearance-none"
        :class="
          errorMessage
            ? 'border-error  bg-danger/5'
            : 'border-gray-300 text-primary bg-gray-50'
        "
        :placeholder="placeholder"
      >
        <!-- <option value="" disabled>
                    {{ $t(placeholder ?? "Please select") }}
                </option> -->
        <slot>
          <option
            v-for="option in options"
            :key="option?.value"
            :value="option?.value || option?.id"
            :selected="option?.selected"
            class="capitalize"
          >
            {{ option?.name }}
          </option>
        </slot>
      </select>
      <div
        class="absolute inset-y-0 right-3 flex items-center pointer-events-none z-50"
      >
        <BaseIcon
          name="expand_more"
          size="24"
          class="text-primary transition duration-150 cursor-pointer"
        ></BaseIcon>
      </div>
    </div>
    <input type="hidden" :name="name" :value="modelValue" />
    <span v-if="errorMessage" class="alert-error block pl-6 mt-2 text-red-600">
      {{ $t(errorMessage || "") }}
    </span>
  </div>
</template>
<script>
import { ref, computed, toRef } from "vue";
import { useField } from "vee-validate";
export default {
  name: "VSelect",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    label: String,
    name: String,
    type: {
      type: String,
      default: "text",
    },
    id: String,
    placeholder: String,
    modelValue: {
      type: String,
      default: "",
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  // methods: {
  //     changeOption(event) {
  //         this.$emit("update:modelValue", event);
  //     },
  // },
  setup(props, { emit }) {
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
      checked,
    } = useField(toRef(props, "name"), undefined, {
      initialValue: computed(() => props.modelValue),
      // checkedValue: toRef(props, "value"),
    });

    const onChange = ({ target }) => {
      handleChange(target.value);
      emit("update:modelValue", target.value);
    };

    return { errorMessage, inputValue, onChange };
  },
};
</script>
